<template>
  <div class="content">
    <div class="question">
      <!-- <div class="text-t">您最想改变的部位是</div>
            <div class="radio-list">
                <div class="radio-item" :class="{ 'radio-item-active': item === questionData.body_part }"
                    v-for="(item, index) in lossPosition" @click="bindSelect(item)" :key="index">
                    <span>{{ item }}</span><span class="iconfont icon-gou" v-if="item === questionData.body_part"></span>
                </div>
            </div>
            <div class="input-content">
                <div class="item-title">您的身高</div>
                <input type="number" v-model="questionData.height" placeholder="输入您的身高">
                <div class="item-unit">cm</div>
            </div>
            <div class="input-content">
                <div class="item-title">您的体重</div>
                <input type="number" v-model="questionData.weight" placeholder="输入您的体重">
                <div class="item-unit">kg</div>
            </div> -->
      <div class="text-t">您的基本信息</div>
      <!--  <div class="input-content">
                <div class="item-title">您的姓名</div>
                <input type="text" v-model="questionData.username" placeholder="输入您的姓名">
            </div> -->
      <div class="input-content">
        <div class="item-title">您的电话</div>
        <div class="input-container">
          <input
            type="number"
            v-model="questionData.phone"
            placeholder="输入您的手机号码"
          />
        </div>
      </div>
      <div class="input-content">
        <div class="item-title">验证码</div>
        <div class="input-container">
          <input
            type="number"
            v-model="questionData.code"
            maxlength="4"
            placeholder="输入验证码"
          />
        </div>
        <div class="send-code" @click="bindSendCode">{{
          codeTime ? codeTime + '秒' : '发送验证码'
        }}</div>
      </div>
    </div>
    <div class="btn-content">
      <div class="btn-item btn-item-confirm" @click="bindSubmit">提交</div>
      <div class="btn-item" @click="bindCancel">取消</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lossPosition: ['腰', '肚子', '手臂', '腿'],
      questionData: {
        areaCode: '86',
        body_part: '腰',
        height: '170',
        weight: '60',
        username: '默认名称',
        phone: '',
        code: '',
        city: ''
      },
      codeTime: 0
    }
  },
  watch: {
    questionData: {
      deep: true,
      handler(data) {
        /* 处理ios复制两次的问题 */
        if (data.code.length > 4) {
          this.questionData.code = this.questionData.code.slice(0, 4)
        }
      }
    }
  },
  methods: {
    bindSelect(item) {
      this.questionData.body_part = item
    },
    checkParams() {
      if (!this.questionData.body_part) {
        this.$toast('请选择您最想改变的部位')
        return false
      }
      if (!this.questionData.height) {
        this.$toast('请输入您的身高')
        return false
      }
      if (!this.questionData.weight) {
        this.$toast('请输入您的体重')
        return false
      }
      if (!this.questionData.username) {
        this.$toast('请输入您的姓名')
        return false
      }
      //判断是否为全汉字
      let reg = /^[\u4e00-\u9fa5]{1,6}(·[\u4e00-\u9fa5]{1,6}){0,2}$/
      let res = reg.test(this.questionData.username)
      if (!res) {
        this.$toast('姓名只能为中文')
        return false
      }
      if (!this.questionData.phone) {
        this.$toast('请输入您的电话')
        return false
      }
      if (this.questionData.phone.length != 11) {
        this.$toast('电话号码必须为11位')
        return false
      }
      if (!this.questionData.code) {
        this.$toast('验证码不能为空')
        return false
      }
      return true
    },
    bindSendCode() {
      if (this.codeTime) {
        return
      } else if (!this.questionData.phone) {
        this.$toast('请输入您的电话')
        return
      } else if (this.questionData.phone.length != 11) {
        this.$toast('电话号码必须为11位')
        return
      }
      let params = {
        areaCode: '86',
        phone: this.questionData.phone
      }
      this.$http
        .postBaseApp('outerSendSms', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('发送成功')
            this.codeTime = 60
            this.timer = setInterval(() => {
              this.codeTime--
              if (this.codeTime <= 0) {
                clearInterval(this.timer)
              }
            }, 1000)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    bindCancel() {
      this.$emit('cancel')
    },
    bindSubmit() {
      if (!this.checkParams()) {
        return
      }
      this.$emit('submit', this.questionData)
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  width: 283px;
  background: #f7f7f7;
  border-radius: 8px;
  overflow: hidden;

  .question {
    padding: 20px 20px 24px;

    .text-t {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(74, 61, 107, 0.5);
      line-height: 20px;
      margin-bottom: 8px;
    }

    .radio-list {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      margin-bottom: 10px;

      .radio-item {
        position: relative;
        width: 115px;
        height: 30px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid #f1f1f1;
        text-align: center;
        line-height: 28px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #4a3d6b;
        margin-right: 13px;
        margin-bottom: 8px;

        .iconfont {
          position: absolute;
          right: 7px;
          top: 50%;
          transform: translate(0%, -50%);
          width: 16px;
          height: 16px;
          border-radius: 50%;
          font-size: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #786aff;
          color: #fff;
          font-weight: 600;
        }
      }

      .radio-item:nth-child(2n) {
        margin-right: 0px;
      }

      .radio-item-active {
        border: 2px solid #786aff;
      }
    }

    .input-content {
      height: 36px;
      background: #ffffff;
      border-radius: 18px;
      border: 1px solid #f1f1f1;
      display: flex;
      align-items: center;
      padding: 0px 18px;
      margin-bottom: 16px;

      .item-title {
        white-space: nowrap;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(74, 61, 107, 0.7);
        line-height: 17px;
        margin-right: 17px;
      }
      .input-container {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
      }
      input {
        width: 100%;
        padding: 0;
        border: none;
        outline: none;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #4a3d6b;
        line-height: 30px;
      }

      input::-webkit-input-placeholder {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(74, 61, 107, 0.3);
        line-height: 17px;
      }

      .item-unit {
        margin-left: 10px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(74, 61, 107, 0.7);
        line-height: 17px;
      }

      .send-code {
        white-space: nowrap;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #4a3d6b;
        line-height: 17px;
      }
    }
  }

  .btn-content {
    display: flex;
    align-items: center;

    .btn-item {
      width: 50%;
      height: 46px;
      box-sizing: border-box;
      background: #ffffff;
      border: 1px solid #f1f1f1;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.8);
      line-height: 46px;
      text-align: center;
    }

    .btn-item-confirm {
      background: #786aff;
      color: #ffffff;
      border: none;
    }
  }
}
</style>
